import styled from "styled-components";
import { TitleColor } from "./Colours";
import { device } from './Responsive';

export const titleH1 = styled.h1`
  font-family: 'Titillium Web', sans-serif;
  color: #000000;
  font-weight: 700;
  font-size: 39px;
  line-height: 48px;
  margin: 0;
  padding: 0;

  @media ${device.desktop} {
    font-size: 34px;
    line-height: 42px;
  }

  @media ${device.laptopL} {
    font-size: 30px;
    line-height: 40px;
  }

  @media ${device.tablet} {
    font-size: 24px;
    line-height: 39px;
  }

  @media ${device.mobileM} {
    font-size: 20px;
    line-height: 26px;
  }
`

export const titleH2 = styled.h2`
  font-family: 'Titillium Web', sans-serif;
  color: #000000;
  font-weight: 700;
  font-size: 36px;
  line-height: 48px;
  margin: 0;
  padding: 0;

  @media ${device.tablet} {
    font-size: 20px;
    line-height: 36px;
  }
`

export const titleH3 = styled.h3`
  font-family: 'Titillium Web', sans-serif;
  color: #000000;
  font-weight: 400;
  font-size: 31px;
  line-height: 39px;
  margin: 0;
  padding: 0;

  @media ${device.tablet} {
    font-size: 18px;
    line-height: 24px;
  }
`

export const titleH4 = styled.h4`
  font-family: 'Titillium Web', sans-serif;
  color: #000000;
  font-weight: 300;
  font-size: 24px;
  line-height: 36px;
  margin: 0;
  padding: 0;

  @media ${device.tablet} {
    font-size: 16px;
    line-height: 20px;
  }
`

export const titleH5 = styled.h5`
  font-family: 'Titillium Web', sans-serif;
  color: #000000;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  margin: 0;
  padding: 0;

  @media ${device.tablet} {
    font-size: 16px;
    line-height: 20px;
  }
`

export const body2 = styled.span`
  color: #000000;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  @media ${device.tablet} {
    font-size: 12px;
    line-height: 16px;
  }
`

export const TitleSurveyH5 = styled.h5`
  font-weight: 800;
  font-size: 26px;
  line-height: 32px;
  color: ${({color}) => color || TitleColor};
  margin-bottom: 25px;

  @media ${device.tablet} {
    font-size: 12px;
    line-height: 16px;
  }
`

export const BodySurvey = styled.span`
  line-height: 22px;
  font-size: 16px;
  color: ${(p) => p.theme.textColor};
  font-weight: 500;

  @media ${device.tablet} {
    font-size: 12px;
    line-height: 16px;
  }
`

export const BodySmallSurvey = styled.div`
  line-height: 18px;
  font-size: 14px;
  color: ${({color}) => color || '#828282'};

  @media ${device.tablet} {
    font-size: 12px;
    line-height: 16px;
  }
`

export const SubTitleSurvey = styled.h6`
  line-height: 24px;
  font-size: 22px;
  color: ${(p) => p.theme.textColor};
  font-weight: bold;

  @media ${device.tablet} {
    font-size: 12px;
    line-height: 16px;
  }
`

export const ButtonTitle = styled.span`
  line-height: 18px;
  font-size: 16px;
  font-weight: bold;

  @media ${device.tablet} {
    font-size: 12px;
    line-height: 16px;
  }
`

export const BodySmall2Survey = styled.div`
  line-height: 14px;
  font-size: 12px;
  color: ${(p) => p.theme.textColor};

  @media ${device.tablet} {
    font-size: 12px;
    line-height: 16px;
  }
`

export const TextHeader2Survey = styled.div`
  line-height: 20px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;

  @media ${device.tablet} {
    font-size: 12px;
    line-height: 16px;
  }
`